<template>
<div class="page_xianli">
    <!-- banner -->
    <!-- <div class="banner"></div> -->
    <!-- 红色区 -->
    <div class="content">
        <!-- 外链 -->
        <div class="link">
			<a class="item_link" :href="item.link ? item.link : '#'"  v-for="item in linkList" :key="item.id">
				<div class="item">
					<div class="item_l" v-if="item.thumb">
						<van-image class="thumb" :src="imageUrl+item.thumb" :show-error="false" :show-loading="false" />
					</div>
					<div class="item_r">
						<div class="title slh">{{ item.title }}</div>
						<div class="time">{{ item.createdAt }}</div>
					</div>
				</div>
			</a>
        </div>
        <!-- 查看更多 -->
        <div class="btnmore" v-if="links.status" @click="loadeMoreLink">
            <div class="text">查看更多</div>
        </div>
        <!-- 排名类型 -->
		<!-- 了解详情的提示 -->
		<div class="mark" @click="goSinglePage(13)">了解活动详情</div>
		<!-- 排名 -->
        <div class="type typeset">
            <div class="tiaofu toleft">
                <div class="line"></div>
            </div>
            <van-tabs v-model="type" line-width="0" line-height="0" @change="changeTab">
                <van-tab :name="0">
                    <template #title>
                        <span class="line">城市排名</span>
                    </template>
                </van-tab>
                <van-tab :name="1">
                    <template #title>
                        <span class="line">呼吁人气</span>
                    </template>
                </van-tab>
                <van-tab :name="2">
                    <template #title>评论助力</template>
                </van-tab>
            </van-tabs>
            <div class="tiaofu toright">
                <div class="line"></div>
            </div>
        </div>
		<!-- 城市 -->
		<div class="citywrap" v-if="type == 0">
            <van-field class="item" v-model="province" readonly right-icon="arrow-down" placeholder="请选择" @click="showProvince = true" />
            <van-field class="item" v-model="city" readonly right-icon="arrow-down" placeholder="请选择" @click="clickCity" />
            <van-field class="item" v-model="area" readonly right-icon="arrow-down" placeholder="请选择" @click="clickArea" />
        </div>
		<!-- 排名 -->
		<div class="rank">
			<div class="item" v-for="(item,index) in xianliList" :key="item.id" @click="goDetail(item)">
				<div class="item_l">
					<div class="level">{{ index+1 }}</div>
					<div class="">
						<van-image fit="cover" v-if="item.userdata && item.userdata.thumb" :src="item.userdata.thumb" class="thumb"  :show-error="false" :show-loading="false" />
						<van-image fit="cover" v-else :src="imageUrl+item.thumb" class="thumb" :show-error="false" :show-loading="false" />
					</div>
					<div class="title slh">{{ item.describe }}</div>
				</div>
				<div :class="type == 2 ? 'num pinglun' : 'num'">{{ type == 2 ? item.comments_num : item.help_num }}</div>
			</div>
		</div>
		<!-- 查看更多 -->
        <div class="btnmore" v-if="xianli.status" @click="loadeMoreXianli">
            <div class="text">查看更多</div>
        </div>
		<!-- 支持单位 -->
		<div class="company long">
			<div class="type">
				<div class="tiaofu toleft">
					<div class="line"></div>
				</div>
				<div class="title">支持单位</div>
				<div class="tiaofu toright">
					<div class="line"></div>
				</div>
			</div>
			<div class="logowrap">
				<a class="logo" v-for="item in companyImgList" :key="item.id" :href="item.link? item.link : '#' ">
					<img :src="imageUrl+item.thumb" alt="" class="tu">
				</a>
				<!-- <div class="logo">
					<img :src="publicPath+'statics/images/logo_red.png'" alt="" class="tu">
				</div>-->
			</div>
			<div class="textwrap">
				<a class="text" v-for="item in conpanyTextList" :key="item.id" :href="item.link ? item.link : '#'">{{ item.title }}</a>
				<!-- <div class="text">单位</div> -->
			</div>
		</div>
    </div>
	<div class="pubbtns">
		<!-- 发起献礼 -->
		<div class="publishBtn" @click="goPublish"></div>
		<!-- 尊享定制 -->
		<div class="publishBtn dingzhi" @click="goDingzhi"></div>
	</div>
    <!-- 省份 -->
    <van-popup v-model="showProvince" position="bottom">
        <van-picker show-toolbar :columns="provinceList" value-key="areaname" @confirm="onConfirmProvince" @cancel="showProvince = false"/>
    </van-popup>
	<!-- 城市 -->
	<van-popup v-model="showCity" position="bottom">
        <van-picker show-toolbar :columns="cityList" value-key="areaname" @confirm="onConfirmCity" @cancel="showCity = false"/>
    </van-popup>
	<!-- 地区 -->
	<van-popup v-model="showArea" position="bottom">
        <van-picker show-toolbar :columns="areaList" value-key="areaname" @confirm="onConfirmArea" @cancel="showArea = false"/>
    </van-popup>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
import { Dialog } from 'vant';

export default {
    name: "xianli-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            type: 1, // 0按城市搜索 1按助力数排序 2按评论数排序
            province: null,
            city: null,
            area: null,
			showProvince: false,
			provinceList: null,
			showCity: false,
			cityList: null,
			showArea: false,
			areaList: null,
			companyImgList: null, // 支持单位 logo
			conpanyTextList: null, // 支持单位 纯文字无logo
			linkList: [], // 外链
			links: {
				page: 1,
				size: 2,
				status: false // 展示更多
			},
			xianliList: [], // 献礼
			xianli: {
				page: 1,
				size: 10,
				status: false // 展示更多
			},
			is_publish: 0, // 当前用户是否发布过献礼 0未发布过 1发布过, 默认为0
			status: null, // 当前用户的献礼状态 0未审核1审核通过-1未通过
			uuid: null // 当前用户的uuid
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
		var that = this
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '献礼',
                    // hiddenBack: true
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						this.uuid = data.result.uuid
						this.getUserPublishState()
                    } else {
                        this.token = "";
						this.uuid = ""
                    }

                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
					that.$bridge.callhandler(
						"sdjy://member/memberInfo",
						memberParams,
						(data) => {
							if (data.code == 200) {
								that.token = data.result.token;
								that.uuid = data.result.uuid
								that.getUserPublishState()
							} else {
								that.token = "";
								that.uuid = ""
							}

						}
					);
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			this.uuid = this.$store.getters.uuid
			if(this.token){
				this.getUserPublishState()
			}
        }
		// 分享
		this.getShareData()
		// 获取省市区列表
		this.getAreaList()
		// 获取外链
		this.getLinklist()
		// 获取支持单位
		this.getCompanyList()
		// 获取献礼列表
		this.getXianliList()
		
    },
    methods: {
		// 外链
		getLinklist(){
			var that = this
			var params = {
				page: that.links.page,
				size:  that.links.size
			}
			that.$api.xianli.linklist(params).then(res=>{
				if(res.code == 200){
					var list = res.result.list
					var total = res.result.total
					if(list && list.length != 0){
						for(var i in list){
							var time = list[i].created_at
							list[i].createdAt = time.split(' ')[0]
						}
						that.linkList = that.linkList.concat(list)
						if(that.linkList.length < total){
							that.links.status = true
						}else{
							that.links.status = false
						}
					}else{
						that.links.status = false
					}
				}
			})
		},
		// 加载更多外链
		loadeMoreLink(){
			var that = this
			that.links.page++
			that.getLinklist()
		},
		// 献礼文章列表
		getXianliList(){
			var that = this
			var params = {
				page: that.xianli.page,
				size: that.xianli.size,
				type: that.type
			}
			if(that.area1){
				params.area1 = that.area1
			}
			if(that.area2){
				params.area2 = that.area2
			}
			if(that.area3){
				params.area3 = that.area3
			}
			that.$api.xianli.list(params).then(res=>{
				if(res.code == 200){
					var list = res.result.list
					var total = res.result.total
					if(list && list.length != 0){
						that.xianliList = that.xianliList.concat(list)
						if(that.xianliList.length < total){
							that.xianli.status = true
						}else{
							that.xianli.status = false
						}
					}else{
						that.xianli.status = false
					}
					
				}
			})
		},
		// 加载更多献礼
		loadeMoreXianli(){
			var that = this
			that.xianli.page++
			that.getXianliList()
		},
		// 切换tab
		changeTab(){
			var that = this
			that.xianli.page = 1
			that.xianliList = []
			that.getXianliList()
			// 清城市
			if(that.type != 0){
				that.resetCityData()
			}
		},
		// 清城市选择时的省市县
		resetCityData(){
			var that = this
			that.province = null
			that.city = null
			that.area = null
			that.provinceList = null
			that.cityList = null
			that.areaList = null
			that.area1 = null
			that.area2 = null
			that.area3 = null
			that.getAreaList()
		},

		// 支持单位
		getCompanyList(){
			var that = this
			that.$api.xianli.supportunitlist().then(res=>{
				if(res.code == 200){
					that.companyImgList = res.result.picture
					that.conpanyTextList = res.result.nopicture
				}
			})
		},
		// 城市弹层
		clickCity(){
			var that = this
			if(that.province){
				that.showCity = true
			}else{
				that.$toast('请先选择省份')
			}
		},
		// 地区弹层
		clickArea(){
			var that = this
			if(that.city){
				that.showArea = true
			}else{
				that.$toast('请先选择城市')
			}
		},
		// 选择省份
		onConfirmProvince(val){
			var that = this
			console.log('选择省份',val)
			that.province = val.areaname
			that.area1 = val.id
			that.showProvince = !that.showProvince
			// 调城市
			that.city = null
			that.area2 = null
			that.area = null
			that.area3 = null
			that.getAreaList(val.id,1)
			// 调列表
			that.xianli.page = 1
			that.xianliList = []
			that.getXianliList()
		},
		// 选择城市
		onConfirmCity(val){
			var that = this
			console.log('选择城市',val)
			that.city = val.areaname
			that.area2 = val.id
			that.showCity = !that.showCity
			// 调地区
			that.area = null
			that.area3 = null
			that.getAreaList(val.id,2)
			// 调列表
			that.xianli.page = 1
			that.xianliList = []
			that.getXianliList()
		},
		// 选择地区
		onConfirmArea(val){
			var that = this
			console.log('选择地区',val)
			that.area = val.areaname
			that.area3 = val.id
			that.showArea = !that.showArea
			// 调列表
			that.xianli.page = 1
			that.xianliList = []
			that.getXianliList()
		},
		// 用户判断我是否发布献礼,及状态
		getUserPublishState(){
			var that = this
			var params = {
				token: that.token
			}
			that.$api.xianli.ispublish(params).then(res=>{
				if(res.code == 200){
					that.is_publish = res.result.is_publish // 0未发布过 1发布过
					that.status = res.result.status // 文章状态0未审核 1审核通过 -1未通过
				}
			})
		},
		showEndZhuli() {
			Dialog.confirm({
                title: '温馨提示',
                message: '尊敬的时代记忆用户，百年献礼活动已结束，感谢您的关注与支持。工作人员正在统计数据，排名及获奖信息将在7月份公布，敬请期待。',
                showConfirmButton:true,
                confirmButtonText: '确定',
				showCancelButton: false,
                // theme: 'round-button',
                }).then(() => {
                    
                });
		},
		// 发布献礼
		goPublish(){
			this.showEndZhuli()
			return
			var that = this
			console.log('当前页面',that.$router.currentRoute.fullPath)
			// 需要先登录
			
			if (!that.token) {
				if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
					var memberParams = {
						data: {
						},
					};
					this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
							if (data.code == 200) {
								this.token = data.result.token;
								this.uuid = data.result.uuid
								this.getUserPublishState()
							} else {
								this.token = "";
								this.uuid = ""
							}

						}
					);
				} else {
					localStorage.setItem('redirect', that.$router.currentRoute.fullPath)
					that.$router.push({
						path: '/login',
					})
				}
				
			}else{
				// 登录状态下的处理
				if(that.is_publish && that.status == 1 ){
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/xianli/detail?from_uuid='+ that.uuid
							}
						}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						// 通过审核
						that.$router.push({
							path: '/xianli/detail',
							query: {
								from_uuid: that.uuid
							}
						})
					}
					
					
				} else if(that.is_publish && that.status != 1){
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/xianli/publish?status='+ that.status
							}
						}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						// 未通过审核
						that.$router.push({
							path: '/xianli/publish',
							query: {
								status: that.status
							}
						})
					}
				}else{
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/xianli/publish'
							}
						}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						// 发布献礼
						that.$router.push({
							path: '/xianli/publish'
						})
					}
					
				}
			}
			
		},
		// 献礼详情
		goDetail(item){
			var that = this
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/xianli/detail?from_uuid='+item.from_uuid
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				that.$router.push({
					path: '/xianli/detail',
					query: {
						from_uuid: item.from_uuid
					}
				})
			}
			
		},
		// 定制
		goDingzhi(){
			var that = this
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/dingzhi/index'
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				that.$router.push('/dingzhi/index')
			}
		},
		// 单页
		goSinglePage(id){
			var that = this
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/single/page?id='+id
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				this.$router.push({
					path: '/single/page',
					query: {
						id: id
					}
				})
			}
			
		},
		// 省市区
		getAreaList(areaid,type){
			var that = this
			// console.log('id====',areaid)
			var params = {}
			if(areaid){
				params.areaid = areaid
			}
			that.$api.xianli.areaList(params).then(res=>{
				if(res.code == 200){
					var list = res.result
					// console.log('省市区',res.result)
					if(type == 2){
						// 地区
						that.areaList = list
					}else if(type == 1){
						// 城市
						that.cityList = list
					}else{
						// 省份
						that.provinceList = list
					}
				}
			})
		},
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '“巧手颂党恩”向建党百年献礼', // 分享标题
                    desc: '用好作、佳作献礼建党百年，展现新时代手工艺人精神风貌', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.domain + that.$publicData.logo, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
